import { DepositForAccount, Statistics, WithdrawalResult } from "@mezo/api"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type PortalState = {
  deposits: DepositForAccount[]
  withdrawals: WithdrawalResult[]
  statistics: Statistics | null
}

const initialState: PortalState = {
  deposits: [],
  withdrawals: [],
  statistics: null,
}

export const portalSlice = createSlice({
  name: "portal",
  initialState,
  reducers: {
    setDeposits: (
      immerState,
      { payload }: { payload: DepositForAccount[] },
    ) => {
      immerState.deposits = payload
    },
    setWithdrawals: (
      immerState,
      { payload }: { payload: WithdrawalResult[] },
    ) => {
      immerState.withdrawals = payload
    },
    setPortalStatistics: (immerState, { payload }: { payload: Statistics }) => {
      immerState.statistics = payload
    },
    resetPortal: (immerState) => {
      immerState.deposits = []
      immerState.withdrawals = []
    },
    updateDepositAutoMigration: (
      immerState,
      action: PayloadAction<{
        depositUuid: string
        isAutoMigrationEnabled: boolean
      }>,
    ) => {
      const {
        payload: { depositUuid, isAutoMigrationEnabled },
      } = action

      immerState.deposits = immerState.deposits.map((deposit) => {
        if (deposit.id !== depositUuid) return deposit
        return { ...deposit, isAutoMigrationEnabled }
      })
    },
  },
})

export const {
  setDeposits,
  setWithdrawals,
  setPortalStatistics,
  resetPortal,
  updateDepositAutoMigration,
} = portalSlice.actions

export default portalSlice.reducer
